import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class Dashboard extends Base {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: null,
            summary: {},
            tasks: []
        };
    }

    componentDidMount() {
        this.httpPost('api/v1/dashboard/get', {})
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        summary: data.summary,
                        tasks: data.tasks,
                        data: data,
                        loading: false
                    });
                } else {
                    this.showErorrMessage(data.message);
                    this.setState({ loading: false });
                }
            });
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;
        const { summary, tasks, loading, data } = this.state;

        let contents = loading ? this.renderLoading() : [
            <Header data={data} />,
            <div className="nk-content ">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title page-title">داشبورد</h3>
                                        <div className="nk-block-des text-soft">
                                            <p>خلاصه وضعیت کارتابل شما</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="nk-block">
                                <div className="row g-gs">
                                    <div className="col-sm-6 col-lg-3">
                                        <div className="card card-bordered">
                                            <div className="card-inner">
                                                <div className="card-title-group align-start mb-2">
                                                    <div className="card-title"><h6 className="title">کل وظایف</h6></div>
                                                </div>
                                                <div className="align-center flex-wrap flex-md-nowrap g-4">
                                                    <div className="nk-sale-data"><span className="amount">{summary.totalAssigned}</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-lg-3">
                                        <div className="card card-bordered">
                                            <div className="card-inner">
                                                <div className="card-title-group align-start mb-2">
                                                    <div className="card-title"><h6 className="title">معوق</h6></div>
                                                </div>
                                                <div className="align-center flex-wrap flex-md-nowrap g-4">
                                                    <div className="nk-sale-data"><span className="amount text-danger">{summary.overdue}</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-lg-3">
                                        <div className="card card-bordered">
                                            <div className="card-inner">
                                                <div className="card-title-group align-start mb-2">
                                                    <div className="card-title"><h6 className="title">امروز</h6></div>
                                                </div>
                                                <div className="align-center flex-wrap flex-md-nowrap g-4">
                                                    <div className="nk-sale-data"><span className="amount text-warning">{summary.today}</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-lg-3">
                                        <div className="card card-bordered">
                                            <div className="card-inner">
                                                <div className="card-title-group align-start mb-2">
                                                    <div className="card-title"><h6 className="title">این هفته</h6></div>
                                                </div>
                                                <div className="align-center flex-wrap flex-md-nowrap g-4">
                                                    <div className="nk-sale-data"><span className="amount text-info">{summary.thisWeek}</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card card-bordered mt-4">
                                    <div className="card-inner">
                                        <h5 className="card-title">وظایف پیش رو</h5>
                                        <div className="nk-tb-list nk-tb-ulist">
                                            <div className="nk-tb-item nk-tb-head">
                                                <div className="nk-tb-col"><span className="sub-text">عنوان</span></div>
                                                <div className="nk-tb-col tb-col-sm"><span className="sub-text">اولویت</span></div>
                                                <div className="nk-tb-col tb-col-sm"><span className="sub-text">سررسید</span></div>
                                                <div className="nk-tb-col tb-col-sm"><span className="sub-text">نوع</span></div>
                                                <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                            </div>
                                            {tasks.map(task => (
                                                <div className="nk-tb-item" key={task.id}>
                                                    <div className="nk-tb-col"><span className="sub-text">{task.title}</span></div>
                                                    <div className="nk-tb-col tb-col-sm"><span className="sub-text">{task.priorityString}</span></div>
                                                    <div className="nk-tb-col tb-col-sm"><span className="sub-text">{task.dueDatePersian}</span></div>
                                                    <div className="nk-tb-col tb-col-sm"><span className="sub-text">{task.categoryString}</span></div>
                                                    <div className="nk-tb-col text-end">
                                                        <NavLink to={`/task/edit/${task.id}/`} className="btn btn-sm btn-primary">مشاهده</NavLink>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
            <Footer />
        ];
        return contents;
    }
}